import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { enGB } from "date-fns/locale"; // Import locale (English UK starts week on Monday)

const MyDatePicker = ({ dates, handleSelectChange }) => {
  // Create an array of allowed dates as Date objects.
  const allowedDates =
  dates?.filter((item) => item.NUMTICKETS > 0)
        .map((item) => {
          const [year, month, day] = item.EVENTDAY.substring(0, 10).split('-');
          return new Date(year, month - 1, day); // Month is 0-based in JS Date
        }) || [];

  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    // If you need to pass a formatted date to your handler, format it here.
    // For example, converting to MM-DD-YYYY:
    const [year, month, day] = date.toISOString().split("T")[0].split("-");
    const formattedDate = `${year}-${month}-${day}`;
    handleSelectChange(formattedDate);
  };

  return (
    <div className="custom-date-picker">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        includeDates={allowedDates}
        dateFormat="dd-MMM-yyyy"
        placeholderText="Select a Date"
        locale={enGB}
      />
    </div>
  );
};

export default MyDatePicker;
